


import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

import BooleanField from "Web/Components/Common/Input/Boolean.vue";
import Form from "Web/Components/Form/Index.vue";
import FormField from "Web/Components/Form/Field.vue";
import PopupWindow from "Web/Components/Popup/Window.vue";
import FormFieldset from "Web/Components/Form/Fieldset.vue";

import { AdsPublications } from "App";

import { $t, EventBus } from "App/IOC";
import { CountDifferentFields } from "App/Externals/Services/Base";

import {
    CustomNotification,
    Field,
    PagerSorter,
    TextFilter
} from "App/Models";

import {
    Activated,
    Dictionary,
    Identifiable,
    Named
} from "App/Contracts";
import { CustomError } from "@IBS/Frontend/Models";

@Component({
    components: {
        BooleanField,
        Field: FormField,
        Fieldset: FormFieldset,
        Form,
        PopupWindow
    }
})
export default class GatewayFtpForm extends Vue {
    @Prop() readonly row?: any;

    /* When true the form renders inline (full page) instead of inside the modal PopupWindow. The
       create flow keeps the modal; the edit flow (too many fields for a popup) opens full page from
       the dedicated single view. Same field markup is reused in both modes. */
    @Prop( { default: false } ) readonly FullPage!: boolean;

    @Ref( "form" )
    private readonly form?: Form;

    private fields: Dictionary<Field> = {};

    private action: Identifiable & Named & Activated = {
        Id: "create",
        Name: $t( "ADS_PUBLICATION_confirmCreate" ),
        Active: true
    };
    private record: any = {};
    private serializers: any = [];
    private fileObj: any = null;
    private imageUrl: string = "";
    private isImageDeleted: boolean = false;
    private ftpModes: any = [{Id: true, Name: "Passive"}, {Id: false, Name: "Active"}];
    private allowSold: boolean = false;

    private async beforeCreate(): Promise<void> {
        this.fields = await AdsPublications.Fields.Get();
    }

    private async getSerializers(): Promise<[any[], CustomError | undefined]> {
        const [ serializers, error ] = 
            await AdsPublications.GetAllSerializers([], new PagerSorter(999));
        return [ serializers, error ];
    }

    private async getFtpMode(): Promise<[any[], CustomError | undefined]> {
        return [ this.ftpModes, undefined ];
    }
    
    /* Called both by the modal footer action (no argument, reads the form ref) and by the inline
       full-page form's own save bar (passes the record). Either way we resolve the record and run
       the same create/update path. */
    private async onFormSubmit(): Promise<void> {
        if( this.form === undefined )
            return;

        this.action.Active = false;

        const record: any | undefined = this.form.GetRecord() as any;
        console.log("record submit ", record);

        if(this.row !== undefined && this.record !== undefined
            && this.row !== null && this.row.Id !== undefined) {
            await this.update(record);
        }
        else {
            await this.create(record);
        }
    }


    private async fileToBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Read file as Data URL (Base64)
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    private toNumericBoolean(value: any): number {
        if(value === undefined || value === null)
            return 0;

        if(typeof value === "string")
            return value === "1" || value.toLowerCase() === "true" ? 1 : 0;

        if(typeof value === "number")
            return value === 1 ? 1 : 0;

        return value === true ? 1 : 0;
    }

    private get allowSoldValue(): boolean {
        return this.allowSold;
    }

    private onAllowSoldChange(value: boolean): void {
        this.allowSold = value;

        /* Toggle hors des FormField : sans ca son changement n'entre pas dans le record
           du Form et la barre Enregistrer ne se declenche pas. On l'injecte pour dirty. */
        if( this.form !== undefined )
            this.form.SetValue( "allowSold", value );
    }

    private async create(record: any): Promise<void> {
        if(this.fileObj) {
            const base64 = await this.fileToBase64(this.fileObj);
            record.File = base64;
        }
        if(record.Passive_mode !== undefined) {           
            record.Passive_mode = record.Passive_mode.Id; 
        }

        record.allowSold = this.allowSold;
        const [ createdRecord, error ] = await AdsPublications.Create( record );

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            this.action.Active = true;
            this.canCreate();

            return;
        }

        EventBus.Publish(
            "Notification",
            CustomNotification.Success(
                $t( "ADS_PUBLICATION_createSuccessTitle" ),
                $t( "ADS_PUBLICATION_createSuccessMessage" )
            )
        );

        const createdData: any = createdRecord as any;
        if( createdData !== undefined && createdData.id !== undefined ) {
            await this.syncGroups(record, createdData.id as number );
        }
        this.$emit( "Create", createdRecord );
    }

    private async syncGroups(record: any, id: number, isUpdate: boolean = false): Promise<void> {
        const differentFields = CountDifferentFields(this.record, record);
        if( Object.keys( differentFields as {} ).length === 0
        || differentFields.Customers === undefined ) {
            EventBus.Publish(
                "Notification",
                CustomNotification.Success(
                    $t( "ADS_PUBLICATION_createSuccessTitle" ),
                    $t( "GLOBAL_nothingToUpdate" )
                )
            );
            return;
        }

        // eslint-disable-next-line max-len
        if(isUpdate &&
        differentFields.Customers !== undefined
        && differentFields.Customers.length === 0
        && this.record.Customers !== undefined
        && this.record.Customers.length > 0) {
            for(const item of this.record.Customers) {
                const data: any = {
                    Id: id,
                    GroupId: item.Group
                };
                // eslint-disable-next-line max-len
                const [ result, error ] = await AdsPublications.DeleteCustomer(this.record.Id, data );
                console.log("result", result);
                if( error !== undefined ) {
                    EventBus.Publish( "Error", error );
                    this.action.Active = true;
                    this.canCreate();
                }
            }
        }
        if(differentFields.Customers !== undefined && differentFields.Customers.length > 0) {
            if(isUpdate && this.record.Customers !== undefined
            && this.record.Customers.length > 0) {
                for(const item of this.record.Customers) {
                    const data: any = {
                        Id: id,
                        GroupId: item.Group
                    };
                    // eslint-disable-next-line max-len
                    const [ result, error ] = await AdsPublications.DeleteCustomer(this.record.Id, data );
                    console.log("result", result);
                    if( error !== undefined ) {
                        EventBus.Publish( "Error", error );
                        this.action.Active = true;
                        this.canCreate();
                    }
                }
            }

            for(const item of record.Customers) {
                const data: any = {
                    Id: id,
                    GroupId: item.Group
                };
                const [ result, error ] = await AdsPublications.CustomerCreate( data);
                console.log("result", result);

                if( error !== undefined ) {
                    EventBus.Publish( "Error", error );
                    this.action.Active = true;
                    this.canCreate();
                }
            }

            EventBus.Publish(
                "Notification",
                CustomNotification.Success(
                    $t( "ADS_PUBLICATION_createSuccessTitle" ),
                    isUpdate ? $t( "ADS_PUBLICATION_UpdateCustomerMessage" )
                        : $t( "ADS_PUBLICATION_createCustomerMessage" )
                )
            );
        }

    }

    private async update(record: any): Promise<void> {
        if(this.fileObj) {
            const base64 = await this.fileToBase64(this.fileObj);
            record.File = base64;
            if(this.record.Image) {
                // eslint-disable-next-line max-len
                const [ result, error ] = await AdsPublications.DeletePicture( this.record.Id );
                console.log(result);
                if( error !== undefined ) {
                    EventBus.Publish( "Error", error );
                }
            }
        } else if(this.isImageDeleted) {
            // eslint-disable-next-line max-len
            const [ result, error ] = await AdsPublications.DeletePicture( this.record.Id );
            console.log(result);
            if( error !== undefined ) {
                EventBus.Publish( "Error", error );
            }
            record.File = undefined;

            const differentFields = CountDifferentFields(this.record, record);
            if( Object.keys( differentFields as {} ).length === 0 ) {
                EventBus.Publish(
                    "Notification",
                    CustomNotification.Success(
                        $t( "ADS_PUBLICATION_createSuccessTitle" ),
                        $t( "ADS_PUBLICATION_createUpdateMessage" )
                    )
                );

                this.$emit( "Create", record );
                return;
            }
        }
        if(record.Passive_mode !== undefined) {           
            record.Passive_mode = record.Passive_mode.Id; 
        }
        record.allowSold = this.allowSold;

        const [ createdRecord, error ] = await AdsPublications.Update( this.record, record );

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            this.action.Active = true;
            this.canCreate();

            return;
        }

        EventBus.Publish(
            "Notification",
            CustomNotification.Success(
                $t( "ADS_PUBLICATION_createSuccessTitle" ),
                $t( "ADS_PUBLICATION_createUpdateMessage" )
            )
        );

        await this.syncGroups(record, this.record.Id as number, true );
        this.$emit( "Create", createdRecord );
    }

    private canCreate(): void {
        if( this.form === undefined )
            return;

        this.action.Active = true;
        // const record = this.form.GetRecord() as any;
        // this.action.Active = record.Name !== undefined && record.Host !== undefined;
    }

    private async getGatewayFormatOptions(): Promise<[any[], undefined]> {
        const result = AdsPublications.PlaceholderData.getGatewayFormatOptions();
        return [ result, undefined ];
    }

    private async getEncodingOptions(): Promise<[any[], undefined]> {
        const result = AdsPublications.PlaceholderData.getEncodingOptions();
        return [ result, undefined ];

    }

    @Watch( "row", { immediate: true } )
    private async onRowChanged(): Promise<void> {
        if( this.row === undefined || this.row === null || this.row === "" ) {
            this.record = {};
            this.allowSold = false;
            return;
        }
        const id = this.row.Id ? this.row.Id : this.row.id;
        this.action.Name = id !== undefined && id !== "" ?
            $t( "ADS_PUBLICATION_confirmUpdate" ) : $t( "ADS_PUBLICATION_confirmCreate" );
        const [ record, error ] = await AdsPublications.Get( id );

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            this.action.Active = true;
            this.canCreate();

            return;
        }

        const formatedRecord = this.capitalizeKeys( record );

        const rawRecord: any = record;
        if(rawRecord !== undefined) {
            let allowSource;
            if( rawRecord.allow_sold !== undefined ) {
                allowSource = rawRecord.allow_sold;
            } else if( rawRecord.allowSold !== undefined ) {
                allowSource = rawRecord.allowSold;
            } else if( rawRecord.Allow_sold !== undefined ) {
                allowSource = rawRecord.Allow_sold;
            } else {
                allowSource = rawRecord.AllowSold;
            }
            this.allowSold = this.toNumericBoolean( allowSource ) === 1;
        } else {
            this.allowSold = false;
        }

        /* Une seule cle allowSold dans le record. Sinon capitalizeKeys/Get laissent aussi AllowSold
           et Allow_sold : cote backend appendValues lowercase tout -> deux "allowsold" en conflit,
           et .get() prend la stale (false) au lieu du toggle. On purge les variantes et on pose la
           baseline en camelCase, seule cle envoyee au backend. */
        delete formatedRecord.AllowSold;
        delete formatedRecord.Allow_sold;
        formatedRecord.allowSold = this.allowSold;

        if(formatedRecord.Distant_folder !== undefined) {
            formatedRecord.DistantFolder = formatedRecord.Distant_folder;
            delete formatedRecord.Distant_folder;
        }

        if(formatedRecord.Password !== undefined) {
            formatedRecord.Password = {
                Value: formatedRecord.Password
            };
        }

        if(formatedRecord.Serializer !== undefined) {
            // formatedRecord.SerializerId =
            //     formatedRecord.Serializer ? formatedRecord.Serializer.id : undefined;
            // formatedRecord.SerializerId = formatedRecord.Serializer;
            const serializerId = formatedRecord.Serializer ? 
                formatedRecord.Serializer.id : undefined;
            const [ serializerOptions, error ] = await this.getSerializers();
            if( serializerOptions !== undefined && error === undefined 
                && serializerId !== undefined ) {
                formatedRecord.Serializer = 
                    serializerOptions.find( x => x.Id === serializerId );
            }
        }
        if(formatedRecord.Format !== undefined) {
            const formatOptions = AdsPublications.PlaceholderData.getGatewayFormatOptions();
            if( formatOptions !== undefined ) {
                formatedRecord.Format =
                    formatOptions.find( x => x.Id === formatedRecord.Format );
            }
        }

        if(formatedRecord.Encoding !== undefined) {
            const encodingOptions = AdsPublications.PlaceholderData.getEncodingOptions();
            if( encodingOptions !== undefined ) {
                formatedRecord.Encoding =
                    encodingOptions.find( x => x.Id === formatedRecord.Encoding );
            }
        }
        if(formatedRecord.Customers !== undefined && formatedRecord.Customers.length > 0) {
            formatedRecord.Customers = formatedRecord.Customers.map(function(item: any) {
                return {
                    Group: item.group,
                    Id: item.id,
                    Name: item.name
                };
            });
        }
        
        if(formatedRecord.Passive_mode !== undefined) {
            formatedRecord.Passive_mode = {
                Id: formatedRecord.Passive_mode, 
                Name: formatedRecord.Passive_mode ?
                    $t("ADS_PUBLICATION_passiveMode") : $t("ADS_PUBLICATION_activeMode")
            };
        }
        this.record = formatedRecord;

        if(this.record !== undefined && this.record.Image !== undefined) {
            this.imageUrl = this.record.Image;
        }
    }

    private capitalizeKeys(obj: any): Record<string, any> {
        const newObj: Record<string, any> = {};
        for(const key in obj) {
            if(obj.hasOwnProperty(key)) {
                const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
                newObj[capitalizedKey] = obj[key];
            }
        }
        return newObj;
    }

    private async handleImageUpload(event: any): Promise<void> {
        const file = event.target.files[0];
        if(!file) return;
        this.fileObj = file;
        this.imageUrl = URL.createObjectURL(file);
        this.markImageChanged( file.name );
    }

    /* ⚠️ LE LOGO VIT HORS DES FormField ( Fred, 24/09/2026 : « quand j'ajoute le
       visuel, il n'est pas reconnu, je n'ai pas la notion d'enregistrement » ).
       Meme cas que `allowSold` : sans ecriture dans le record du Form, la barre
       Enregistrer ne s'allume pas. On y pose `File` — `create` et `update` le
       remplacent par le base64, ou le vident quand le logo est retire. */
    private markImageChanged( value: string | null ): void {
        if( this.form !== undefined )
            this.form.SetValue( "File", value );
    }
    private async handleImageDelete(): Promise<void> {
        if(this.record && this.record.Id && this.record.Image) {

            EventBus.Publish("Confirmation", {
                Props: {
                    Title: this.$t("GLOBAL_attention"),

                    Message: this.$tc("ADS_PUBLICATION_deleteImageConfirm"),

                    Actions: [{
                        Id: "endTrial",
                        Name: this.$t("GLOBAL_actionDelete"),
                        Active: true
                    }]
                },
                Events: {
                    Action: async () => {
                        // eslint-disable-next-line max-len
                        // const [ result, error ] = await AdsPublications.DeletePicture( this.record.Id );

                        // if( error !== undefined ) {
                        //     EventBus.Publish( "Error", error );
                        //     this.action.Active = true;
                        //     this.canCreate();
                        //     return;
                        // }
                        // EventBus.Publish(
                        //     "Notification",
                        //     CustomNotification.Success(
                        //         $t( "ADS_PUBLICATION_createSuccessTitle" ),
                        //         $t( "ADS_PUBLICATION_createDeleteMessage" )
                        //     )
                        // );
                        this.fileObj = null;
                        this.imageUrl = "";
                        this.isImageDeleted = true;
                        this.markImageChanged( null );
                        // this.$emit( "Create", result );

                    }
                }
            });

        } else {
            this.fileObj = null;
            this.imageUrl = "";
        }
    }

    private async getCustomers( keyword?: string ): Promise<[ any[], CustomError | undefined ]> {
        /* Show the whole groups list when the field opens without typing, so each portal exposes
           its groups directly. Typing narrows the list via the Name filter. */
        const filters: TextFilter[] = [];

        if( keyword !== undefined && keyword !== "" ) {
            const filter = new TextFilter( "Name", "" );
            filter.Value = [ keyword ];
            filters.push( filter );
        }

        const [ result, , error ] =
        await AdsPublications.GetAllCustomers( filters, new PagerSorter( 999 ) );

        return [ result, error ];
    }
}
